<template>
  <div>
    <div class="dropdown" v-if="this.data.export_enabled && !this.isExporting">
      <button class="report_button dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
        Export report
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li><a class="dropdown-item" href="#" @click="printReport('PDF')">PDF</a></li>
        <li><a class="dropdown-item" href="#" @click="printReport('PPTX')">PPTX</a></li>
      </ul>
    </div>

    <div class="progress" id="progress_background" v-if="this.isExporting">
      <div class="progress_text" id="progress_indicator">
        {{ exportText }}
      </div>
    </div>

    <div
      :id="`reportContainer${id}`"
      class="report-container"/>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client'
import axios from 'axios'
import $ from 'jquery'

export default {
  name: 'Report',
  props: {
    id: {
      type: String
    },
    data: {
      type: Object
    },
    customConfig: {
      type: Object,
      default: () => {
      }
    },
    powerBIPrefix: {
      type: String,
      default: 'https://api.powerbi.com/v1.0/myorg/reports'
    }
  },
  data () {
    return {
      config: {},
      isMobile: {
        Android: function () {
          return navigator.userAgent.match(/Android/i)
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i)
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i)
        }
      },
      reportRefer: null,
      intervalId: {
        type: Object,
        default: () => {}
      },
      isExporting: false,
      exportText: '',
      jsonRulesIsEmpty: true
    }
  },
  computed: {
    isAny () {
      return (this.isMobile.Android() || this.isMobile.iOS() || this.isMobile.Windows())
    }
  },
  mounted () {
    if (this.data.embedUrl) {
      this.configureReport()
      this.getReport()
    }
    if (window.matchMedia('(max-width: 766px)').matches) {
      var widthBuffer = 10
      var heightBuffer = 10
      $(`#reportContainer${this.id}`).height($(window).height() - (heightBuffer))
      $(`#reportContainer${this.id}`).width($(window).width() - widthBuffer)
      $(window).resize(function () {
        $(`#reportContainer${this.id}`).height($(window).height() - (heightBuffer))
        $(`#reportContainer${this.id}`).width($(window).width() - widthBuffer)
      })
    }
  },
  methods: {
    async getAccessToken () {
      const response = await axios.get(this.data.url, {
        headers: { 'portalbi-Subscription-Key': this.data.subscriptionKey }
      })
      return response.data.access_token
    },
    getRelativeDateOperators (operators, models) {
      if (operators.includes('InLast')) {
        return models.RelativeDateOperators.InLast
      } else if (operators.includes('InThis')) {
        return models.RelativeDateOperators.InThis
      } else if (operators.includes('InNext')) {
        return models.RelativeDateOperators.InNext
      } else if (operators.includes('Between')) {
        return models.RelativeDateOperators.Between
      } else if (operators.includes('NotIn')) {
        return models.RelativeDateOperators.NotIn
      } else if (operators.includes('This')) {
        return models.RelativeDateOperators.This
      } else if (operators.includes('Last')) {
        return models.RelativeDateOperators.Last
      } else if (operators.includes('Next')) {
        return models.RelativeDateOperators.Next
      } else if (operators.includes('All')) {
        return models.RelativeDateOperators.All
      } else {
        return models.RelativeDateOperators.InLast
      }
    },
    getRelativeDateUnits (units, models) {
      if (units.includes('Days')) {
        return models.RelativeDateFilterTimeUnit.Days
      } else if (units.includes('Weeks')) {
        return models.RelativeDateFilterTimeUnit.Weeks
      } else if (units.includes('Months')) {
        return models.RelativeDateFilterTimeUnit.Months
      } else if (units.includes('Years')) {
        return models.RelativeDateFilterTimeUnit.Years
      } else {
        return models.RelativeDateFilterTimeUnit.Days
      }
    },
    configureReport () {
      const models = pbi.models

      const json_rules = this.data.json_rules && Array.isArray(this.data.json_rules) ? this.data.json_rules : []
      if (json_rules.length > 0 && typeof json_rules[0] === 'object' && json_rules[0] !== null) {
        this.jsonRulesIsEmpty = false
        json_rules[0].forEach((rule) => {
          if (rule && Object.keys(rule).length > 0) {
            const filterType = rule.$schema.trim()
            // rule.operator = models.RelativeDateOperators.InLast
            // rule.timeUnitType = models.RelativeDateFilterTimeUnit.Years
            switch (filterType) {
              case 'http://powerbi.com/product/schema#basic':
                rule.filterType = models.FilterType.BasicFilter
                break
              case 'http://powerbi.com/product/schema#relativeDate':
                rule.filterType = models.FilterType.RelativeDate
                rule.operator = this.getRelativeDateOperators(rule.operator, models)
                rule.timeUnitType = this.getRelativeDateUnits(rule.timeUnitType, models)
                break
              case 'http://powerbi.com/product/schema#relativeTime':
                rule.filterType = models.FilterType.RelativeTime
                break
              case 'http://powerbi.com/product/schema#topN':
                rule.filterType = models.FilterType.TopN
                break
              case 'http://powerbi.com/product/schema#advanced':
                rule.filterType = models.FilterType.AdvancedFilter
                break
              default:
                rule.filterType = models.FilterType.Unknown
                break
            }
          }
        })

        this.config = {
          type: 'report',
          id: this.data.embedReportId,
          embedUrl: this.data.embedUrl,
          tokenType: models.TokenType.Aad,
          permissions: models.Permissions.Read,
          viewMode: models.ViewMode.View,
          settings: {
            filterPaneEnabled: false,
            layoutType: this.isAny ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
            background: this.isAny ? models.BackgroundType.Transparent : models.BackgroundType.Default,
            customLayout: {
              displayOption: models.DisplayOption.FitToPage
            },
            panes: {
              pageNavigation: {
                visible: true,
                position: models.PageNavigationPosition.Left
              }
            }
          },
          filters: json_rules[0]
        }
      } else {
        this.jsonRulesIsEmpty = true
        this.config = {
          type: 'report',
          id: this.data.embedReportId,
          embedUrl: this.data.embedUrl,
          tokenType: models.TokenType.Aad,
          permissions: models.Permissions.Read,
          viewMode: models.ViewMode.View,
          settings: {
            filterPaneEnabled: false,
            layoutType: this.isAny ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
            background: this.isAny ? models.BackgroundType.Transparent : models.BackgroundType.Default,
            customLayout: {
              displayOption: models.DisplayOption.FitToPage
            },
            panes: {
              pageNavigation: {
                visible: true,
                position: models.PageNavigationPosition.Left
              }
            }
          }
        }
      }
    },
    async getReport () {
      try {
        this.renderReport(await this.getAccessToken())
      } catch (error) {
        if (this.$state) {
          this.$state.commit('setGlobalError', {
            error: `Un error ha ocurrido al cargar el reporte. Detalle : ${error}`
          })
        }
        Array.from(document.getElementsByTagName('iframe')).forEach(it => {
          it.style.border = 0
        })
      }
    },
    renderReport (accessToken) {
      const $reportContainer = document.getElementById(`reportContainer${this.id}`)
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )
      this.reportRefer = powerbi.embed($reportContainer, {
        ...this.config,
        ...this.customConfig,
        accessToken
      })
      var _this = this
      this.reportRefer.on('dataSelected', () => {
        _this.$emit('click')
      })
      document.getElementsByTagName('iframe').forEach(it => {
        it.style.border = 0
      })
    },
    async getPrintReportResponse (reportId, bookmark) {
      const url = `${this.powerBIPrefix}/${reportId}/ExportTo`

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await this.getAccessToken()}`
        },
        body: JSON.stringify(bookmark)
      }

      const response = await fetch(url, options)

      if (response.ok) {
        return response.json()
      } else {
        return await response.text().then(errorText => {
          return JSON.parse(errorText)
        })
      }
    },
    async getExportStatus (reportId, exportId) {
      const url = `${this.powerBIPrefix}/${reportId}/exports/${exportId}`

      const options = {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await this.getAccessToken()}`
        }
      }

      const response = await fetch(url, options)

      if (response.ok) {
        return response.json()
      } else {
        return await response.text().then(errorText => {
          return JSON.parse(errorText)
        })
      }
    },
    async downloadReport (path) {
      const url = `${path}`

      const options = {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${await this.getAccessToken()}`
        },
        responseType: 'blob'
      }

      const response = await fetch(url, options)

      if (response.ok) {
        return response.blob()
      } else {
        return await response.text().then(errorText => {
          return JSON.parse(errorText)
        })
      }
    },
    downloadBlob (blob, fileName = this.data.embedReportId) {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.dispatchEvent(
        new MouseEvent('click'), {
          bubbles: true,
          cancelable: true,
          view: window
        }
      )
      document.body.removeChild(a)
    },
    async validateExportStatus (idExportacion, format) {
      // eslint-disable-next-line no-unused-vars
      let resultStatus, processIndicator, processBackground, errorMessage, generateDownloadContainer, downloadStatus, successMessageContainer
      // eslint-disable-next-line prefer-const
      resultStatus = await this.getExportStatus(this.data.embedReportId, idExportacion)

      // Update loading indicator with progress percentage
      // eslint-disable-next-line prefer-const
      processIndicator = document.getElementById('progress_indicator')
      // processIndicator = document.getElementById('loadingIndicatorText')
      // eslint-disable-next-line prefer-const
      processBackground = document.getElementById('progress_background')
      // processBackground = document.getElementById('loadingIndicator')
      if (processIndicator) {
        this.exportText = `${resultStatus.percentComplete}%`
      }

      switch (resultStatus.status) {
        case 'Failed':
          clearInterval(this.intervalId) // Stop checking status periodically
          // Display error message
          // eslint-disable-next-line no-case-declarations
          const progressIndicator = document.getElementById('progress_indicator')
          progressIndicator.backgroundColor = '#ba1616'
          this.exportText = 'Error al generar el informe.'
          setTimeout(() => {
            this.isExporting = false
            progressIndicator.backgroundColor = '#4fba16'
            document.body.removeChild(errorMessage)
          }, 5000)
          break
        case 'Succeeded':
          clearInterval(this.intervalId) // Stop checking status periodically

          // Download the generated report
          downloadStatus = await this.downloadReport(resultStatus.resourceLocation)
          var fileName = ''
          if (format === 'PDF') {
            fileName = 'Generacion_Reporte.pdf'
          } else if (format === 'PPTX') {
            fileName = 'Generacion_Reporte.pptx'
          }
          this.downloadBlob(downloadStatus, fileName)

          // Display success message using JavaScript equivalent of Swal.fire
          this.exportText = 'Completado!'

          setTimeout(() => {
            this.isExporting = false
          }, 5000)
          break
      }
    },
    async printReport (format) {
      const capturedBookmark = await this.reportRefer.bookmarksManager.capture()
      let urlFilter = ''
      if (this.jsonRulesIsEmpty) {
        urlFilter = null
      } else {
        let i = 0
        for (const formatedRulesKey of this.data.rules_formated) {
          console.log('formatedRulesKey', formatedRulesKey, this.data.json_rules[0][i])
          /* const filter = {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: this.data.formated_rules[formatedRulesKey][0].table,
              column: this.data.formated_rules[formatedRulesKey][0].column
            },
            operator: 'In',
            values: this.data.formated_rules[formatedRulesKey][0].values
          } */
          const table = encodeURIComponent(formatedRulesKey.Table)
          const column = encodeURIComponent(formatedRulesKey.Column)
          const values = formatedRulesKey.Values || [] // Default to empty array if undefined
          const operator = formatedRulesKey.Operator ? formatedRulesKey.Operator.toLowerCase() : ''
          let filterCondition = ''

          console.log('properties', table, column, values, operator)

          if (this.data.json_rules[0][i].$schema === 'http://powerbi.com/product/schema#relativeDate') {
            // Handling RelativeDate RLS as previously described
            const endDate = new Date()
            const startDate = new Date()
            startDate.setDate(endDate.getDate() - 7)

            // Format dates to YYYY-MM-DD which is acceptable by Power BI URL filters
            const formattedStartDate = startDate.toISOString().split('T')[0]
            const formattedEndDate = endDate.toISOString().split('T')[0]

            const dates = [formattedStartDate, formattedEndDate] // Override values with calculated date range
            filterCondition = `ge '${dates[0]}' and ${table}/${column} le '${dates[1]}'`
            const isLastKey = formatedRulesKey === this.data.rules_formated[this.data.rules_formated.length - 1]
            urlFilter += `${table}/${column} ${filterCondition}${isLastKey ? '' : ' and '}`
          } else {
            if (values.length === 0) {
              continue
            } else if (operator !== 'in') {
              filterCondition = `'${values[0]}'`
            } else {
              const valuesString = values.map(value => `'${value}'`).join(',')
              filterCondition = `(${valuesString})`
            }
            const isLastKey = formatedRulesKey === this.data.rules_formated[this.data.rules_formated.length - 1]
            urlFilter += `${table}/${column} ${operator} ${filterCondition}${isLastKey ? '' : ' and '}`
          }
          i++
        }
      }

      console.log('Final URL Filter:', urlFilter)

      const data = {
        format: format,
        powerBIReportConfiguration: {
          settings: {
            locale: 'en-US',
            excludeHiddenPages: 'false'
          },
          defaultBookmark: {
            state: capturedBookmark.state
          },
          reportLevelFilters: urlFilter ? [{ filter: urlFilter }] : null
        }
      }

      console.log('data', data)
      this.isExporting = true
      this.exportText = 'Generando...'

      try {
        const resultStatus = await this.getPrintReportResponse(this.data.embedReportId, data)

        if (!resultStatus.id) {
          throw new Error('Error al generar el informe.')
        }

        // Check report generation status periodically using ValidarStatusExportacion function
        await this.validateExportStatus(resultStatus.id, format)
        this.intervalId = setInterval(async () => {
          await this.validateExportStatus(resultStatus.id, format)
        }, 1000)
      } catch (error) {
        // Display error message
        this.exportText = 'Error al generar el informe.'

        setTimeout(() => {
          this.isExporting = false
        }, 5000)
      }
    },
    resetReport () {
      const $reportContainer = document.getElementById(`reportContainer${this.id}`)
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )
      powerbi.reset($reportContainer)
    }
  }
}
</script>

<style lang="scss" scoped>
.report-container {
  width: 100%;
  height: 900px;
  min-width: 967px;

  @media(max-width: 766px) {
    min-width: initial;
  }

  iframe {
    border: 0 !important;
  }
}

.dropdown,
.progress {
  position: relative;
  display: inline-block;
  right: 0;
  left: 85%;
  padding-right: 10px;
}

// for 900px width
@media (max-width: 900px) {
  .dropdown,
  .progress {
    position: relative;
    display: inline-block;
    right: 0;
    left: 83%;
    padding-right: 10px;
  }
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.progress_text,
.dropdown-toggle {
  width: 150px;
  color: white;
  padding: 12px;
  font-size: 14px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}

.progress_text {
  background-color: #4fba16;
}

.dropdown-toggle {
  background-color: #004884;
}

.dropdown-menu {
  display: none;
  position: absolute;
  min-width: 150px;
  z-index: 1;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #f9f9f9;
  border-radius: 8px;
  top: 100%; /* Adjust this value as needed */
}

.dropdown-menu a {
  color: #004884;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-menu a:hover {
  background-color: rgba(0, 72, 132, 0.5);
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-toggle:hover, .dropdown-toggle:focus {
  background-color: #004884;
}
</style>
